export default __webpack_public_path__ + "static/28-c4bb8a093ed094f123162e802b0ec48d.png";